import { UserType } from 'types'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { AuthStore } from '../stores'
import { UserSettings } from 'views/settings/userSettings'
import { ManagerSettings } from 'views/settings/managerSettings'
export interface ISettingsProps {
  authStore?: AuthStore
}

/**
 * Shows the account settings of the current user
 *
 * @type Participant, Manager, Admin, Editor, Group
 */

export const Settings = inject('authStore')(
  observer((props: ISettingsProps): JSX.Element => {
    const { authStore } = props
    const isManagerAccess =
      authStore.getCurUserType === 'admin' ||
      authStore.getCurUserType === 'manager'

    if (isManagerAccess) {
      return <ManagerSettings showHelpSettings={false} />
    } else {
      return <UserSettings showHelpSettings={false} />
    }
  })
)
